import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    headerPage: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '30px',
        lineHeight: '37px',
        color: '#182D55'
    },
    slideHeaderText: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '22px',
        color: '#182D55'
    },
    slideDescriptionText: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '20px',
        color: '#7D95A5',
        marginTop: '1em',
        width: '90%'
    },
    learnMoreText: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#1BABE2',
        marginTop: '1em',
        cursor: 'pointer',
        width: '7.5em'
    },
    pointsRewardsContainer: {
        background: '#FFF',
        marginTop: '30px',
        boxShadow: '0px 1px 40px rgba(0, 0, 0, 0.05)',
        borderRadius: '4px',
        height: '864px',
        paddingLeft: '30px',
        paddingTop: '30px'
    },
    labelInsideContainer: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '22px',
        color: '#182D55'
    },
    textRowPrimary: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontSize: '13px',
        lineHeight: '20px',
        color: '#182D55',
        height: '60px'
    },
    totalSatoshi: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#7D95A5'
    },
    satoshiNumber: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold!important',
        color: '#182D55'
    },
    dollarAmount: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '600!important',
        fontSize: '13px',
        lineHeight: '20px',
        color: '#237EB4'
    },
    rewardHistory: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold!important',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#1BABE2',
        cursor: 'pointer'
    }
});

export default useStyles;
